// extracted by mini-css-extract-plugin
export var backdropBlur = "_l6-0";
export var contentCard = "_l6-5";
export var frame = "_l6-2";
export var image = "_l6-4";
export var imagePane = "_l6-3";
export var modal = "_l6-1";